import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { map } from 'rxjs/operators';

import {
    ClearErrorsGroupEditorRegions,
    clearErrorsGroupEditorRegions
} from '../../actions/groupsEdit';
import {
    changeFilterTextRegionsEditor,
    ChangeFilterTextRegionsEditor,
    DESELECT_QUICK_REGIONS_EDITOR_ITEM,
    DESELECT_REGIONS_EDITOR_ITEM,
    SELECT_QUICK_REGIONS_EDITOR_ITEM,
    SELECT_REGIONS_EDITOR_ITEM,
    SelectRegionsEditorItem,
    START_CHANGE_FILTER_TEXT_REGIONS_EDITOR,
    StartChangeFilterTextRegionsEditor
} from '../../actions/regionsEditor';
import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';

const DEBOUNCE_TIME = 1000;

const startChangeFilterTextRegionsEditorEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$
        .ofType(START_CHANGE_FILTER_TEXT_REGIONS_EDITOR)
        .debounceTime(DEBOUNCE_TIME)
        .map(
            (
                action: StartChangeFilterTextRegionsEditor
            ): ChangeFilterTextRegionsEditor => {
                return changeFilterTextRegionsEditor(
                    action.id,
                    action.value,
                    action.tree
                );
            }
        );
};

const selectRegionsEditorItemEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = action$ => {
    return action$.pipe(
        ofType(
            SELECT_REGIONS_EDITOR_ITEM,
            SELECT_QUICK_REGIONS_EDITOR_ITEM,
            DESELECT_QUICK_REGIONS_EDITOR_ITEM,
            DESELECT_REGIONS_EDITOR_ITEM
        ),
        map(
            (
                action: SelectRegionsEditorItem
            ): ClearErrorsGroupEditorRegions => {
                return clearErrorsGroupEditorRegions(action.id);
            }
        )
    );
};

export { startChangeFilterTextRegionsEditorEpic, selectRegionsEditorItemEpic };
